import React, { useState } from 'react';
import Radio from '../../../CommonComponents/Radio/Radio';
import './LensPackages.scss';

const LensPackages = props => {
  const {
    lensPackageDetails,
    lensType,
    packageDetailId,
    handlePackageDetail,
    dataLocale,
    setOpenSideBarPopup,
    currentItemData,
  } = props;
  const {
    SELECTED,
    PACKAGE_PRICE,
    PRICE_DIFFERENCE,
    COVERED_BENEFITS,
    LENS_PACKAGES,
    SELECT_FROM_THE_AVAILABLE_LENS_PACKAGES,
    CONTINUE,
    THERE_IS_NO_PACKAGE,
    PACKAGE_NOT_AVAILABLE_UPGRADATION,
  } = dataLocale;
  const [packageId, setPackageId] = useState(packageDetailId);
  const [touched, setTouched] = useState(false);
  const changeLensPackageDetail = packageDetailId => {
    setTouched(true);
    setPackageId(packageDetailId);
  };
  const submitLensPackage = () => {
    handlePackageDetail(packageId);
  };
  const showPackage = value => {
    const isEligible = value && value.isEligibleForUpgrade;
    return (
      <div
        key={parseInt(Math.random() * 100000, 10)}
        className="padding-0 margin-b16 padding-r4 padding-l4"
        title={`${!isEligible ? PACKAGE_NOT_AVAILABLE_UPGRADATION : ''}`}
      >
        <div
          className={`border-green padding-24 bg-grey border-radius8 display-flex ${
            !isEligible ? 'border-lightgray' : ''
          }`}
        >
          <div className={`${!isEligible ? 'disable' : ''} margin-r12`}>
            <Radio
              disabled
              checked={value.id === packageId}
              className="padding-0-important"
              onClick={() => changeLensPackageDetail(value.id)}
            />
          </div>
          <div className="flex-1">
            <div className="fs16 fw400 margin-b12 display-flex">
              <div className={`${!isEligible ? 'disable' : ''}`}>{value.label}</div>
              {value.id === packageDetailId ? <div className="selected fs13">{SELECTED}</div> : ''}
            </div>
            <div className={`fs18 fs400 margin-b5 ${!isEligible ? 'disable' : ''}`}>
              {PACKAGE_PRICE}: ₹ {value?.prices?.[3]?.price}
            </div>
            <div className={`fs12 fw500 margin-b11 ${!isEligible ? 'disable' : ''}`}>
              {PRICE_DIFFERENCE}: ₹{' '}
              {Math.round(
                Math.abs(
                  value?.prices?.[3]?.price -
                    currentItemData?.options?.[0]?.catalogPrices?.[1]?.value
                )
              )}
            </div>
            <div
              className={`fs13 fw500 color-light-grey margin-b11 ${!isEligible ? 'disable' : ''}`}
            >
              {COVERED_BENEFITS}
            </div>
            {value &&
              value.specificationList &&
              value.specificationList.map(title => {
                return (
                  <div
                    key={parseInt(Math.random() * 100000, 10)}
                    className={`fs14 fw400 margin-b5 display-flex ${!isEligible ? 'disable' : ''}`}
                  >
                    <div>
                      <i className="fa fa-check margin-r11"></i>
                    </div>
                    <div>{title?.title}</div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    );
  };

  const onClose = () => {
    setPackageId(packageDetailId);
    setOpenSideBarPopup(false);
  };

  return (
    <>
      <div className="header-wrapper">
        <span className="back-arrow" onClick={() => onClose()}>
          <i className="fa fa-arrow-left fs11 cursor-pointer" />
        </span>
        <div>
          <span className="fs20 fw500">{LENS_PACKAGES}</span>
        </div>
      </div>
      <div className="bg-white body-padding margin-24">
        <div className="margin-l8 margin-b20 fs14 fw400">
          {SELECT_FROM_THE_AVAILABLE_LENS_PACKAGES}
        </div>
        <div className="display-flex">
          {lensPackageDetails?.packages?.length === 0 && (
            <h3 className="margin-l8">{THERE_IS_NO_PACKAGE}</h3>
          )}
          {lensPackageDetails?.packages?.map(detail => {
            if (detail.id.toLowerCase() === lensType.toLowerCase()) {
              if (detail?.packages?.length === 0) {
                return <h3 className="margin-l8">{THERE_IS_NO_PACKAGE}</h3>;
              }
              /* To show Packages in First column */
              return (
                <div
                  key={parseInt(Math.random() * 100000, 10)}
                  className="padding-0 margin-0 flex-column width-50"
                >
                  {detail.packages.map((value, index) => {
                    if (index % 2 === 0) return showPackage(value);
                    return '';
                  })}
                </div>
              );
            }
            return '';
          })}
          {lensPackageDetails?.packages?.map(detail => {
            if (
              detail.id.toLowerCase() === lensType.toLowerCase() &&
              detail?.packages?.length !== 0
            ) {
              /* To show Packages in Second column */
              return (
                <div
                  key={parseInt(Math.random() * 100000, 10)}
                  className="padding-0 margin-0 flex-column width-50"
                >
                  {detail.packages.map((value, index) => {
                    if (index % 2 === 1) return showPackage(value);
                    return '';
                  })}
                </div>
              );
            }
            return '';
          })}
        </div>
      </div>
      <div className="button-wrapper">
        <div
          className={`button ${touched ? '' : 'button-disable'}`}
          onClick={() => submitLensPackage()}
        >
          {CONTINUE}
        </div>
      </div>
    </>
  );
};

export default LensPackages;
